export const DEFAULT_LABEL_BACKGROUND_COLOR = "#2B2E3A";
export const DEFAULT_LABEL_TEXT_COLOR = "#96F3C3";
